export const GET_KENZER_INTEGRATION = 'GET_KENZER_INTEGRATION'
export const GENERATE_KENZER_KEY = 'GENERATE_KENZER_KEY'
export const SAVE_KENZER_CONFIG = 'SAVE_KENZER_CONFIG'
export const DISCONNECT_KENZER = 'DISCONNECT_KENZER'
export const LAUNCH_KENZER_SSO = 'LAUNCH_KENZER_SSO'
export const GET_SMS_INTEGRATIONS = 'GET_SMS_INTEGRATIONS'
export const CREATE_SMS_INTEGRATION_CONNECTION = 'CREATE_SMS_INTEGRATION_CONNECTION'
export const UPDATE_SMS_INTEGRATION_CONNECTION = 'UPDATE_SMS_INTEGRATION_CONNECTION'
export const DELETE_SMS_INTEGRATION_CONNECTION = 'DELETE_SMS_INTEGRATION_CONNECTION'
export const SET_SMS_INTEGRATION_BRANCHES = 'SET_SMS_INTEGRATION_BRANCHES'
export const TEST_SMS_INTEGRATION_CONNECTION = 'TEST_SMS_INTEGRATION_CONNECTION'
export const GET_SMS_INTEGRATION_ACTIVITY = 'GET_SMS_INTEGRATION_ACTIVITY'
